import { render, staticRenderFns } from "./gallery-thumbnails.vue?vue&type=template&id=af5c4500&scoped=true&"
import script from "./gallery-thumbnails.vue?vue&type=script&lang=ts&"
export * from "./gallery-thumbnails.vue?vue&type=script&lang=ts&"
import style0 from "./gallery-thumbnails.vue?vue&type=style&index=0&id=af5c4500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c4500",
  null
  
)

export default component.exports